<template>
  <b-field
    :label="labelPosition == 'top' ? label : null"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
  >
    <b-switch
      :value="value"
      :type="type"
      :size="size"
      :true-value="trueValue"
      :false-value="falseValue"
      :class="{'is-danger': hasError()}"
      :disabled="disabled"
      @input="inputListener($event)"
    >
      {{ labelPosition == 'right' ? label : null }}
    </b-switch>
  </b-field>
</template>

<script>
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      type: Boolean
    },
    type: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: undefined
    },
    trueValue: {
      type: String,
      default: undefined
    },
    falseValue: {
      type: String,
      default: undefined
    },
    labelPosition: {
      type: String,
      default: "top"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
